export default __webpack_public_path__ + "media/img/img_placeholder-0887a1e4d4e89155ba1fcb8f17d432ae.svg";